import styled from 'styled-components';
import { Table } from 'antd';

export const StyledTable = styled(Table)``;

export default StyledTable;
